/* eslint-disable max-lines */
import { Event, EventHint, SdkInfo } from '@sentry/core';
import { NodeClient } from '@sentry/node';
import { app } from 'electron';
import { SDK_VERSION } from './version.js';

export const SDK_NAME = 'sentry.javascript.electron';

/** Gets SDK info */
export function getSdkInfo(sendDefaultPii: boolean): SdkInfo {
  return {
    name: SDK_NAME,
    packages: [
      {
        name: 'npm:@sentry/electron',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
    settings: { infer_ip: sendDefaultPii ? 'auto' : 'never' },
  };
}

/** Gets the default release name */
export function getDefaultReleaseName(): string {
  const app_name = app.name || app.getName();
  return `${app_name.replace(/\W/g, '-')}@${app.getVersion()}`;
}

/** Gets the default environment */
export function getDefaultEnvironment(): string {
  return app.isPackaged ? 'production' : 'development';
}

/**
 * Gets the default event data by calling all event processors.
 */
export async function getEventDefaults(client: NodeClient): Promise<Event> {
  let event: Event | null = { message: 'test' };
  const eventHint: EventHint = {};

  for (const processor of client.getEventProcessors()) {
    if (event === null) break;
    event = await processor(event, eventHint);
  }

  delete event?.message;

  return event || {};
}
